import { RolesSchema, UsernameSchema } from '@vy/types';
import { oz } from '@vy/utils';

export const InviteMemberFormSchema = oz.object({
  email: UsernameSchema,
  firstName: oz.string().optional(),
  lastName: oz.string().optional(),
  role: RolesSchema,
});

export type InviteMemberFormValues = oz.infer<typeof InviteMemberFormSchema>;
